export default __webpack_public_path__ + "static/2-2c401ff0dcb77564b992e3d97bffca74.png";